<template>
  <div class="page">
    <div class="title font-weight-black text-left">Data file</div>
    <p> Please see the following example data file. The column names marked in "red" are required. </p>
    <p> The first three columns should be named as "SampleID", "SubjectID", and "Group", respectively. </p>
    <p>For the "Group" variable, only two values can be used, i.e. "train" and "test". If there is no data for test, all
      values should be set as "train". </p>
    <p> For outcome variables, their initials must be set as "Y" and serialized by adding Arabic numerals if needed,
      e.g., Y1, Y2, Y3. In this module, the survival time (Y1) and status (Y2) must be provided.</p>
    <p> For exposure variables, their initials must be set as "X" and serialized by adding Arabic numerals if needed,
      e.g., X1, X2, X3. </p>
    <p> For covariate variables, their initials must be set as "C" and serialized by adding Arabic numerals if needed,
      e.g., C1, C2, C3. It should be noted the covariates are not required if users don’t have.</p>

    <br>
    <v-data-table :headers="dataHeaders" :items="dataRowData" items-per-page="5"></v-data-table>
    <br>
    <div class="title font-weight-black text-left">Vocabulary file</div>
    <p> Please see the following example data file. The column names marked in "red" is required. </p>
    <p> The first two columns must be named as "SerialNo" and "FullName", respectively. </p>
    <p> The list of SerialNo of outcomes, exposure, and covariates should be the same with the column names of "Data
      file". </p>
    <p> The list of the FullName is prepared as users’ like. </p>
    <p> For "GroupName", the unique group labels for each omic data must be provided, e.g., chemical, exposure,
      metabolome, immuome, and proteome. </p>
    <br>
    <v-data-table :headers="vocaHeaders" :items="vocaRowData" items-per-page="5"></v-data-table>
  </div>
</template>

<script>
import datafileImg from '@/assets/expomo/data file.png';
import vocabularyImg from '@/assets/expomo/vocabulary file.png';
import axios from 'axios';

export default {
  data() {
    return {
      datafileImg,
      vocabularyImg,
      dataHeaders: [],
      dataRowData:[],
      vocaHeaders: [],
      vocaRowData:[],
    }
  },
  async mounted() {
    await this.doAllTable()
  },  
  methods: {
    async doAllTable() {
      const dataRsp = await this.doTable("ExpoData.csv");
      this.dataHeaders = dataRsp["header"]
      this.dataRowData = dataRsp["node"]

      const vocaRsp = await this.doTable("ExpoVoca.csv");
      this.vocaHeaders = vocaRsp["header"]
      this.vocaRowData = vocaRsp["node"]
    },
    async doTable(filename) {
      let data = JSON.stringify({
        "path": "demo/",
        "filename": filename
      });
      try {
        const response = await axios.post('/exposome/getdemofile', data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        return this.$globalParseCsvData(response.data)
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.figure {
  margin: 2em 0;
  text-align: center;
}

.figure-img {
  margin-bottom: 1em;
}

p {
  text-indent: 2em;
  margin-bottom: 1em;
  word-break: break-word;
  overflow: hidden;
  line-height: $line-height-small;
}

.page {
  margin: 2em 12em;
  font-size: $webpage-base-font-size;
  font-family: $paper-page-font-family;
}

.title {
  font-size: $webpage-large-font-size;
  margin: 1em 0 0.6em;
}

@media screen and (max-width: 600px) {
  .page {
    margin: 1em 2em;
  }
}

</style>
